import { render, staticRenderFns } from "./detailSkillsRightItem.vue?vue&type=template&id=7d54b883&scoped=true"
import script from "./detailSkillsRightItem.vue?vue&type=script&lang=js"
export * from "./detailSkillsRightItem.vue?vue&type=script&lang=js"
import style0 from "./detailSkillsRightItem.vue?vue&type=style&index=0&id=7d54b883&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d54b883",
  null
  
)

export default component.exports